import { cn } from 'cn';
import { type PropsWithChildren } from 'react';

import { Icon } from '@vestigas/ui';

type P = PropsWithChildren<{
  readonly isOpen: boolean;
  readonly onOpen: (isOpen: boolean) => void;
  readonly testId?: string;
}>;

export const MultiItemsManagerHeader = ({
  children,
  isOpen,
  onOpen,
  testId,
}: P) => (
  <button
    className={cn(
      'flex w-full cursor-pointer items-center gap-1.5 px-2 py-1 text-lg',
      {
        'border-b border-tiga-border-lighter': isOpen,
      },
    )}
    data-testid={testId}
    type="button"
    onClick={(event) => {
      event.stopPropagation();
      event.preventDefault();
    }}
    onMouseDown={() => {
      onOpen(!isOpen);
    }}
  >
    {children}
    <div className="ml-auto size-10 p-2">
      <Icon
        className={cn('-mt-1 transition-transform', {
          '-rotate-90': isOpen,
          'rotate-90': !isOpen,
        })}
        metaphor="chevronRight"
      />
    </div>
  </button>
);
